import { UserCheck, ClipboardList, Mail, FileText, Video, Workflow } from "lucide-react"

const features = [
  {
    icon: UserCheck,
    title: "Employee Self-Login",
    description:
      "New hires receive a secure invite link and log in to complete their own onboarding.",
  },
  {
    icon: ClipboardList,
    title: "Onboarding Workflows",
    description:
      "Build custom onboarding workflows with tasks, approvals and deadlines. Assign them to employees and track progress in real time.",
  },
  {
    icon: FileText,
    title: "Digital Document Collection",
    description:
      "Collect contracts, ID documents and compliance forms digitally. Employees upload directly from their device — no printing needed.",
  },
  {
    icon: Mail,
    title: "Automated Invite Emails",
    description:
      "Send onboarding invitations automatically when a new employee is added. Keep everyone informed from day one.",
  },
  {
    icon: Video,
    title: "Welcome Video",
    description:
      "Upload a personalised welcome video for your organisation. New employees see it the moment they log in for the first time.",
  },
  {
    icon: Workflow,
    title: "Live Workflow Tracking",
    description:
      "Monitor every employee's onboarding progress live. See which tasks are complete, pending or overdue at a glance.",
  },
]

export default function OnboardingFeaturesSection() {
  return (
    <section id="onboarding-features" className="py-24 bg-gradient-to-br from-[#1b237a] via-[#1a2a8f] to-[#163b8f]">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {/* Heading */}
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-md font-bold text-cyan-400 uppercase tracking-widest mb-3">
            Employee Onboarding
          </p>
          <h2 className="text-4xl sm:text-5xl font-bold text-white">
            Onboard faster, stress-free
          </h2>
          <p className="mt-4 text-base text-white/70">
            Give new hires a smooth first-day experience while your team stays
            on top of every step — automatically.
          </p>
        </div>

        {/* Cards */}
        <div className="mx-auto mt-16 grid max-w-lg grid-cols-1 gap-8 lg:max-w-none lg:grid-cols-3">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="relative rounded-2xl border border-white/20 bg-white/10 backdrop-blur-sm p-8 hover:bg-white/15 transition-all duration-200"
            >
              <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-cyan-400/20">
                <feature.icon className="h-6 w-6 text-cyan-400" />
              </div>
              <h3 className="text-lg font-semibold text-white">
                {feature.title}
              </h3>
              <p className="mt-3 text-sm text-white/70 leading-relaxed">
                {feature.description}
              </p>
              {/* Bottom accent */}
              <div className="absolute bottom-0 left-0 h-1 w-full rounded-b-2xl bg-gradient-to-r from-cyan-400 to-[#1A237E]" />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
